const IconEditCompany = ({ className }) => {
    return (
        <svg width='28' height='29' viewBox='0 0 28 29' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M13.5 19H19.125M27 14.5C27 21.6797 21.1797 27.5 14 27.5C6.8203 27.5 1 21.6797 1 14.5C1 7.3203 6.8203 1.5 14 1.5C21.1797 1.5 27 7.3203 27 14.5ZM16.3125 8.68764C16.5611 8.439 16.8984 8.29932 17.25 8.29932C17.4241 8.29932 17.5965 8.33361 17.7574 8.40024C17.9182 8.46687 18.0644 8.56453 18.1875 8.68764C18.3106 8.81076 18.4083 8.95691 18.4749 9.11777C18.5415 9.27863 18.5758 9.45103 18.5758 9.62514C18.5758 9.79925 18.5415 9.97166 18.4749 10.1325C18.4083 10.2934 18.3106 10.4395 18.1875 10.5626L10.375 18.3751L7.875 19.0001L8.5 16.5001L16.3125 8.68764Z'
                stroke='white'
                strokeWidth='1.42857'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconEditCompany;
